import React from 'react';
import { useMutation, gql } from '@apollo/client';
import SignIn from './SignIn';

const SIGN_IN = gql`
  mutation ($email: String!, $password: String!) {
    loginLocal(email: $email, password: $password)
  }
`;

function SignInData(props) {
  const [signIn] = useMutation(SIGN_IN);

  return <SignIn signIn={signIn} {...props} />;
}

export default SignInData;
